enum WorkspaceProjectCarbonAndLandRightsAgreementFeatures {
  'Agreement includes details about Carbon Rights' = 'Agreement includes details about Carbon Rights',
  'Agreement includes details about Benefit sharing' = 'Agreement includes details about Benefit sharing',
  'Agreement includes productive, conservation, or restoration activities (or a combination of them)' = 'Agreement includes productive, conservation, or restoration activities (or a combination of them)',
  'Agreement includes rights to ecosystem services' = 'Agreement includes rights to ecosystem services',
  'Agreement(s) signed' = 'Agreement(s) signed',
}

export default WorkspaceProjectCarbonAndLandRightsAgreementFeatures
